import { Button } from '@/ui/button/button';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { useTranslation } from 'react-i18next';
import { FeedEmptyState } from './feed-empty-state';
import type { ContentItem } from '@/api/v4/content-items.api';
import { useContentItemTableConfiguration } from './use-content-items-table-configuration';
import type { ContentItemSortKey } from './feed.state';
import { contentItemsSortState } from './feed.state';
import { InfiniteScrollTableJotai } from '@/ui/table/infinite-table/infinite-scroll-table-jotai';
import { INFINITE_TABLE_ROW_HEIGHT } from '@/ui/table/infinite-table/table-body';
import { useContentItems } from './use-content-items.query';
import { useToggleContentItemSidebar } from './sidebar/use-toggle-content-item-sidebar';

export const Feed = () => {
  const { t } = useTranslation('settings', { keyPrefix: 'feedTab' });

  const { data = [], isLoading } = useContentItems();
  const { navigateToContentItemSidebar } = useToggleContentItemSidebar();

  const { rows, header } = useContentItemTableConfiguration();

  return (
    <>
      <Flexbox justify="right">
        <Button
          startIcon="Plus"
          onClick={() => navigateToContentItemSidebar()}
        >{t`uploadArticle`}</Button>
      </Flexbox>

      {data.length === 0 ? (
        <FeedEmptyState onUploadButtonClick={navigateToContentItemSidebar} />
      ) : (
        <InfiniteScrollTableJotai<ContentItem, ContentItemSortKey>
          id="content-items"
          data={data}
          isLoading={isLoading}
          sortState={contentItemsSortState}
          hasMore={false}
          headers={header}
          rows={rows}
          height={`${INFINITE_TABLE_ROW_HEIGHT * 4}px`}
        />
      )}
    </>
  );
};
